/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentDataset } from './VoiceAgentDataset';
import {
  VoiceAgentDatasetFromJSON,
  VoiceAgentDatasetFromJSONTyped,
  VoiceAgentDatasetToJSON,
} from './VoiceAgentDataset';

/**
 *
 * @export
 * @interface PaginatedVoiceAgentDatasetList
 */
export interface PaginatedVoiceAgentDatasetList {
  /**
   *
   * @type {number}
   * @memberof PaginatedVoiceAgentDatasetList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedVoiceAgentDatasetList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedVoiceAgentDatasetList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<VoiceAgentDataset>}
   * @memberof PaginatedVoiceAgentDatasetList
   */
  results: Array<VoiceAgentDataset>;
}

/**
 * Check if a given object implements the PaginatedVoiceAgentDatasetList interface.
 */
export function instanceOfPaginatedVoiceAgentDatasetList(value: object): value is PaginatedVoiceAgentDatasetList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedVoiceAgentDatasetListFromJSON(json: any): PaginatedVoiceAgentDatasetList {
  return PaginatedVoiceAgentDatasetListFromJSONTyped(json, false);
}

export function PaginatedVoiceAgentDatasetListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedVoiceAgentDatasetList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(VoiceAgentDatasetFromJSON),
  };
}

export function PaginatedVoiceAgentDatasetListToJSON(value?: PaginatedVoiceAgentDatasetList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(VoiceAgentDatasetToJSON),
  };
}
